import { Stack, spacing, Text } from '@scality/core-ui';
import { Icon } from '../Icon';
import { fontWeight } from '@scality/core-ui/dist/style/theme';
import type React from 'react';
import styled from 'styled-components';
import type { LandingPage } from '../../gen/openapi/models/LandingPage';
import { IncomingChatBox } from './ChatCard';
import { GuardianMarkdown } from './GuardianMarkdown';

const LandingPageContainer = styled(IncomingChatBox)`
  display: flex;
  flex-direction: column;
  view-transition-name: landing-page;
  animation: incomingFadeInUpCard 0.5s ease-out forwards;
`;

const ContentContainer = styled.div`
  width: 100%;
  text-align: left;
  strong {
    font-weight: ${fontWeight.bold};
  }
  em {
    font-style: italic;
    color: ${(props) => props.theme.textSecondary};
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.r4};
`;

interface AgentLandingPageProps {
  landingPage: LandingPage | null;
  agentIcon: string;
  agentName: string;
}

export const AgentLandingPage: React.FC<AgentLandingPageProps> = ({ landingPage, agentIcon, agentName }) => {
  const title = landingPage?.title ?? agentName;
  const tagline = landingPage?.tagline;
  const content = landingPage?.content ?? 'Send a message to get started.';

  return (
    <LandingPageContainer shouldAnimate={false}>
      <Header>
        <Stack direction="horizontal">
          <Icon name={agentIcon} size="lg" />
          <Text variant="Larger" color="textPrimary" isEmphazed>
            {title}
          </Text>
        </Stack>
        {tagline && (
          <Text variant="Small" color="textSecondary">
            {tagline}
          </Text>
        )}
      </Header>

      <ContentContainer>
        <GuardianMarkdown md={content} isLastResponse />
      </ContentContainer>
    </LandingPageContainer>
  );
};
